<template>
  <violation-rule-form :rule="rule"></violation-rule-form>
</template>
<script>

import ViolationRuleForm from './violationRuleForm'
import {ViolationRule} from '../../../object'

export default {
  name: 'NewViolationRule',
  components: {ViolationRuleForm},
  data: () => ({
    rule: new ViolationRule()
  })
}
</script>

<style scoped>

</style>
